import { render, staticRenderFns } from "./OpenCards.vue?vue&type=template&id=4f2369a0&"
import script from "./OpenCards.vue?vue&type=script&lang=ts&"
export * from "./OpenCards.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports